import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

let releaseStage: string;

if (window.env.RIDEIQ_APP_DOMAIN_PREFIX) {
  releaseStage = window.env.RIDEIQ_APP_DOMAIN_PREFIX;
} else {
  releaseStage = (window.env.RIDEIQ_SUBENVIRONMENT || window.env.RIDEIQ_ENVIRONMENT || 'local')
    .toLowerCase()
    .replace('dev', 'staging');
}

const ignoredReleaseStages = ['local']; // Environment where Bugsnag should be disabled

window.env.RIDEIQ_BUGSNAG_API_KEY &&
  !ignoredReleaseStages.includes(releaseStage) &&
  Bugsnag.start({
    apiKey: window.env.RIDEIQ_BUGSNAG_API_KEY,
    appVersion: process.env.RIDEIQ_RELEASE_SHA,
    plugins: [new BugsnagPluginReact()],
    releaseStage: releaseStage,
    onError: (event) => {
      // Discard errors from third-party vendor Refiner failing to load its external script.
      // This is non-critical — Refiner is a survey tool and the app functions without it.
      if (event.errors.some((e) => e.errorMessage?.includes('Could not load Refiner client'))) {
        return false;
      }

      // Drop the spec-defined ResizeObserver loop notification (W3C ResizeObserver §3.4.6).
      // This fires when a ResizeObserver callback causes layout changes within the same frame
      // and is benign — triggered by MUI components (Tabs, Tooltip) on the rider detail page.
      if (event.errors.some((e) => e.errorMessage?.startsWith('ResizeObserver loop'))) {
        return false;
      }

      return true;
    },
  });
